import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
    Box,
    Typography,
    Paper,
    TextField,
    Button,
} from "@mui/material";
import { GetUserId } from "./HelperFunctions";
import { GetUserName } from "./HelperFunctions";
import { BASE_URL } from "../config/network/ApiUrl";

function CommentSection({ user, currentStory, commentRef, setCommentCountData }) {
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);
    const [commentData, setCommentData] = useState({});
    const [error, setError] = useState(false);

    const commentInputRef = useRef(null);

    console.log("currentStory in CommentSection ", currentStory)
    console.log("user details", user)
    console.log("commentData", commentData)


    const fetchComments = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}api/comment/node/${currentStory?.id}?refresh=${new Date().getTime()}`,

            );
            console.log("get comment data", res)
            setCommentData(res?.data);
            setCommentCountData(res?.data)
        } catch (err) {
            console.error("Error fetching like data:", err);
        }
    };


    useEffect(() => {
        // if (!currentStory?.id) return;    
        fetchComments();
    }, [currentStory?.id]);




    // ⭐ Expose a focus function
    React.useImperativeHandle(commentRef?.commentRef, () => ({
        focusCommentBox() {
            if (commentInputRef.current) {
                commentInputRef.current.focus();
            }
        },
    }));

    const handleSubmit = async () => {
        if (!comment.trim()) {
            setError(true);   // 👈 show error
            return;
        }

        setError(false);      // 👈 hide error if valid
        const body = {
            "entity_type": "node",
            "entity_id": currentStory?.id,
            "comment_body": comment,
            "subject": comment?.substring(0, 35),
            "format": "plain_text",
            "email": GetUserId(),
            "user_name": GetUserName()

        }
        console.log("comment body", body)
        setLoading(true);
        try {
            const res = await axios.post(`${BASE_URL}api/comment`, body);
            console.log("comment API response", res)
            fetchComments()
            setCommentData(res?.data);
            setCommentCountData(res?.data)
            setComment("");
            setLoading(false);
        } catch (err) {
            console.log("Error posting comment:", err);
            alert("Failed to submit comment");
        }

    };

    return (
        <Box
           sx={{
    width: "100%",
    maxWidth: "700px",
    margin: "0 auto",
    mt: 4,

    /* 📱 Mobile width handling */
    "@media (max-width: 600px)": {
        maxWidth: "90%",   // override 700px
        width: "100%",
        padding: "0 12px",  // optional spacing so content isn’t touching the edges
    }
}}          
            className="mobilePadding"
        >

            {/* Comments Count */}
            <Typography
                sx={{ fontSize: "16px", fontFamily: "'open_sansbold'", fontWeight: 400, color: "#212529" }}
            >
                {`${commentData?.total_comments ? commentData?.total_comments : 0} Comments`}
            </Typography>

            {/* Comment Box Section */}
            <Paper
                elevation={1}
                sx={{
                    p: 2,
                    mt: 1,
                    backgroundColor: "#eaeaea",
                    borderRadius: "15px",
                }}
            >
                {/* Comment Input */}
                <TextField
                    fullWidth
                    multiline
                    minRows={1}
                    placeholder="Share your comment"
                    value={comment}
                    inputRef={commentInputRef}
                    onChange={(e) => {
                        setComment(e.target.value);
                        if (e.target.value.trim().length > 0) {
                            setError(false);   // 👈 Hide error as soon as user types
                        }
                    }}
                    sx={{
                        backgroundColor: "white",
                        borderRadius: "10px",
                        "& textarea": { fontSize: "16px" },
                        mb: 2,
                    }}
                />

                {/* Submit Button BELOW & Right aligned */}
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                        sx={{
                            backgroundColor: "#ffffff",
                            color: "#212529",
                            textTransform: "none",
                            fontWeight: 600,
                            px: 4,
                            py: 1.2,
                            lineHeight:"1rem",
                            borderRadius: "20px",
                            fontFamily: "'open_sansregular'",
                           
                        }}
                    >
                        {loading ? "Submitting..." : "Submit"}
                    </Button>
                </Box>


            </Paper>

            <Box sx={{ marginTop: "4%" }}>
                {error && (
                    <Typography
                        sx={{
                            color: "#F00",
                            fontSize: "14px",
                            lineHeight:"14px",
                            fontFamily: "'OpenSans-Regular'",
                        }}
                    >
                        Please enter comment
                    </Typography>
                )}

            </Box>



            {/* 🔥 SHOW COMMENTS BELOW COMMENT BOX  */}
            {commentData?.comments?.length > 0 && (
                <Box sx={{ mt: 3 }}>
                    {commentData?.comments?.map((item) => (
                        <Paper
                            key={item.id}
                            elevation={0}
                            sx={{
                                p: 2,
                                mb: 2,
                                borderRadius: "15px",
                                border: "1px solid #adadad",
                                backgroundColor: "white",
                            }}
                        >
                            {/* User + Time */}
                            <Typography
                                sx={{
                                    fontSize: "15px",
                                    // fontWeight: 600,
                                    lineHeight: "20px",
                                    color: "#212529",
                                    fontFamily: "'open_sansbold'",
                                }}
                            >
                                {item?.user_name}{" "}
                                <span style={{ color: "#767676", fontSize: "11px", fontFamily: "'OpenSans-Regular'", lineHeight: "11px", }}>
                                    {item?.created_ago}
                                </span>
                            </Typography>

                            {/* Comment text */}
                            <Typography
                                sx={{
                                    // mt: 0.6,
                                    fontSize: "15px",
                                    fontFamily: "'OpenSans-Regular'",
                                    color: "#212529",
                                    lineHeight: "20px",
                                }}
                            >
                                {item?.comment_body}
                            </Typography>
                        </Paper>
                    ))}
                </Box>
            )}

        </Box>
    );
}

export default CommentSection;
